import React from "react";
import {
  AiFillLinkedin,
  AiFillGithub,
  AiOutlineInstagram,
  AiFillMediumSquare,
} from "react-icons/ai";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="icons">
        <a href="https://medium.com/@zenestekin" target="_blank">
          <AiFillMediumSquare className="icon" />
        </a>
        <a href="https://www.linkedin.com/in/enestekin/" target="_blank">
          <AiFillLinkedin className="icon" />
        </a>
        <a href="https://github.com/enestekin" target="_blank">
          <AiFillGithub className="icon" />
        </a>
        <a href="https://www.instagram.com/zenestekin/" target="_blank">
          <AiOutlineInstagram className="icon" />
        </a>
      </div>
      <p>Built with React &copy; Enes Tekin 2021</p>
    </footer>
  );
};

export default Footer;
